// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__wrHhG","connectionsBtn":"Dashboard_connectionsBtn__5qgNI"};